import { render, staticRenderFns } from "./ProfileIntro.vue?vue&type=template&id=e221cf3e&scoped=true&"
import script from "./ProfileIntro.vue?vue&type=script&lang=js&"
export * from "./ProfileIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e221cf3e",
  null
  
)

export default component.exports